import { render } from "./PrimaryEvent.vue?vue&type=template&id=7c5ab358&scoped=true&ts=true"
import script from "./PrimaryEvent.vue?vue&type=script&lang=ts"
export * from "./PrimaryEvent.vue?vue&type=script&lang=ts"

import "./PrimaryEvent.vue?vue&type=style&index=0&id=7c5ab358&lang=scss&scoped=true"

import exportComponent from "C:\\BuildAgent\\work\\e394cd1ec4c7054f\\src\\TicketSolutions.Personalisation.Client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c5ab358"]])

export default __exports__